import { Schema } from 'effect';
/**
 * A site short name, as it appears in a route path (`:site`/`:siteId`).
 *
 * The id becomes a Firestore document path (`sites/<id>/...`), so the shape is
 * constrained to what the signup UI produces — lowercase letters, digits and
 * hyphens, 3–30 chars — which carries no path-segment metacharacters. Reusing
 * this on every route param rejects a malformed id (a '/', '.', space or
 * uppercase) with a 400 at the boundary, before any handler builds a path, so
 * the path-injection shape behind F-AUTHZ-17 cannot reach a handler through a
 * new route that forgot to check. The backend keeps `verifySiteId`
 * (`packages/shared/src/paths.ts`) as the path-layer backstop for non-HTTP
 * callers (CLI, triggers, jobs).
 */
export const SiteId = Schema.String.check(Schema.isPattern(/^[a-z0-9-]{3,30}$/));
//# sourceMappingURL=common.js.map